import { useEffect, useState } from "react";
import { ErrorContext } from "../../utils/context/error";
import { getMessageAll, getMessageAllxArea, setBloqueaMessage } from "../../services/mensaje";
import IconM from "../dashboard/menu/icons/Icon";
import MessageModal from "./messagemodal";
import useTable from "../../hooks/table";
import TableFooter from "../../hooks/table/footer";

function MessageView() {
  const [Area, setArea] = useState([]);
  const [mensaje, setMensaje] = useState([]);

  const { setShowToast, setOpciones } = ErrorContext();
  const [AreaId, setAreaId] = useState(0);
  const [AreaFId, setAreaFId] = useState(0);
  const [MensajeId, setMensajeId] = useState(0);
  const [showM, setShowM] = useState(false);
  const [tag, setTag] = useState(0);
  const [estado, setEstado] = useState("AC");
  const [selectedRow, setSelectedRow] = useState(null);
  const [page, setPage] = useState(1);
  const { slice, range } = useTable(mensaje, page, 10);
    
  /**
   * Metodo para mostrar las areas en la grilla
   */
  const fillMessage = async () => {
    setShowToast(false);
    
    const response = await getMessageAll();
    if (response) {
      if (response.status === 200) {
        setMensaje(response.data.data);
        setArea(response.data.area);
      } else {
        const Mensaje = response.message;
        const opc = { type: "Danger", message: Mensaje, active: true };
        setOpciones(opc);
        setShowToast(true);
      }
    }
  };
  // boton crear-Editar-Eliminar Area
  const handleCrearMensaje = (tagId) => {
    
    if (tagId === 0) {
      setAreaId(AreaFId);
      setMensajeId(0);
    }
    setShowM(true);
    setTag(tagId);
  };
  // Bloquea- Desbloquea
  const handleBloqueaMensaje = async (tagId) => {
    setShowToast(false);
    const response = await setBloqueaMessage(AreaId, MensajeId, tagId);
    if (response) {
      if (response.status === 200) {
        const actualizado = response.data.data[0];
        setMensaje(prev =>
             prev.map((item, idx) =>
                   idx === selectedRow
                ? { ...item, Estado: actualizado.Estado, AreaId: actualizado.AreaId }
          : item
      )
    );
          setTag(0);
          setEstado(actualizado.Estado);
          setAreaId(actualizado.AreaId);
          //handleFiltrar(AreaFId);
      } else {
        const Mensaje = response.message;
        const opc = { type: "Danger", message: Mensaje, active: true };
        setOpciones(opc);
        setShowToast(true);
      }
    }
  };
  /**
   * al dar click en la fila
   */
  const handlefilas = (Item, index) => 
  {
    setSelectedRow(index);  
    setAreaId(Item.AreaId);
    setMensajeId(Item.MensajeId);
    setEstado(Item.Estado);
  };
   /**
   * Filtrar por area
   */
  const handleFiltrar =async(area) =>{
    let response=[];
    setAreaFId(area);
    
    if (area ===0) 
    { 
      response = await getMessageAll();
    }  
    else 
    { 
      response = await getMessageAllxArea(area);
    }  
    if (response) {
      if (response.status === 200) {
        setMensaje(response.data.data);
       
      } else {
        const Mensaje = response.message;
        const opc = { type: "Danger", message: Mensaje, active: true };
        setOpciones(opc);
        setShowToast(true);
      }
    }   
  }
  //------------------------------------------------------------------------
  const handleFiltrarInt =async(data) =>
    {
      const actualizado = data;
      if (tag ===0)
       {
         setMensaje(prev => 
          {
            const existe = prev.some(
               item => item.AreaId === actualizado.AreaId && item.MensajeId === actualizado.MensajeId
             );
             return existe ? prev : [...prev, actualizado];
          });
       }
      
      if (tag ===1)
      {
         
        setMensaje(prev =>
             prev.map((item, idx) =>
                   idx === selectedRow
                ? { ...item, Estado: actualizado.Estado, AreaId: actualizado.AreaId, Mensaje: actualizado.Mensaje }
               : item
             )
          );
        setEstado(actualizado.Estado);
        setAreaId(actualizado.AreaId);
      }    
     
      if (tag ===2)
      {
        setMensaje(prev => prev.filter(item => item.AreaId === AreaId && item.MensajeId !== MensajeId));
        setSelectedRow(null);
      }  
     
    
          setTag(0);
          
  }
  
  /**
   *Llamada al iniciar
   */
  useEffect(() => {
    setShowM(false);
    fillMessage();
  }, []);

  return (
    <>
        <div className="">
         <div className="paneltitle">
            <label className="text-[1.0rem] font-light text-gray-400 leading-none">Administración/Digiturno/Mensajes</label>
         </div>
        <div className="panelmenu">
            <button className="btnmenu" onClick={() => handleCrearMensaje(0)} >
              <IconM svg="newfile" className="iconmenu" title="newfile" />
              <span>Nuevo</span>
            </button>
            
            <button className="btnmenu" id="Editar" disabled={selectedRow === null} onClick={() => handleCrearMensaje(1)}>
              <IconM svg="pencil" className="iconmenu" title="pencil" />
              <span>Editar</span>
            </button>
       
            <button className="btnmenu" id="Eliminar" onClick={() => handleCrearMensaje(2)} disabled={selectedRow === null}>
              <IconM svg="delfile" className="iconmenu" title="delfile" />
              <span>Eliminar</span>
            </button>

            {estado === "AC" ? 
            (
               <button className="btnmenu" id="Bloquear" disabled={selectedRow === null} onClick={() =>handleBloqueaMensaje(0)}>
                   <IconM svg="lock" className="iconmenu" title="lock" />
                   <span>Bloquear</span>
                </button>
            ) : 
            (
              <button className="btnmenu" id="Desbloquear" disabled={selectedRow === null} onClick={() =>handleBloqueaMensaje(1)}>
                 <IconM svg="dlock" className="iconmenu" title="dlock"/>
                 <span>Desbloquear</span>
              </button>
            )}
        </div>
        <div className="mt-2 rounded-lg border border-stone-200 overflow-x-auto">
         <table className="w-full table-auto min-w-[700px]">
            <thead className="border-b border-stone-200 text-sm font-medium ">
               <tr>
                   <th className="hidden md:table-cell px-2.5 py-2 text-start font-medium">Id.</th>
                   <th className="px-2.5 py-2 text-start font-medium">Area</th>
                   <th className="px-2.5 py-2 text-start font-medium">Mensaje</th>
                   <th className="px-2.5 py-2 text-start font-medium">Estado</th>
               </tr>
            </thead>
            <tbody className="group text-sm text-stone-800 ">
               {slice.map((item, index) => {
                  return (
                    <tr className={`border-b border-stone-200 last:border-0 ${selectedRow === index ? 'bg-blue-50 selected cursor-pointer' : ''}`} key={index} id={`fila${item.MensajeId}`} onClick={() => handlefilas(item, index)}>
                       <td className="hidden md:table-cell">{item.MensajeId}</td>
                       <td>{item.NombreArea}</td>
                       <td>{item.Mensaje}</td>
                       <td className="item-center">
                          {item.Estado === "AC" ? (<span className="tagac">Activo</span>) : (<span className="tagan">Suspendido</span>)}
                       </td>
                    </tr>
                  )})}
            </tbody>
         </table>

        </div>
       <TableFooter range={range} slice={slice} setPage={setPage} page={page} />
     </div>
      <MessageModal
        show={showM}
        AreaI={AreaId}
        AreaFId ={AreaFId}
        MensajeI={MensajeId}
        Tag={tag}
        handleshow={setShowM}
        handleFiltrar={handleFiltrarInt}
      ></MessageModal>
    </>
  );
}
export default MessageView;
